import React, { Component } from "react";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current:
        window.location.href === "http://localhost:3000/"
          ? "http://localhost:3000/#home/"
          : window.location.href,
      id: "home-page",
    };
  }
  render() {
    if (this.props.data) {
      var occupation = this.props.data.occupation;
      var description = this.props.data.description;
      var city = this.props.data.address.city;
      var networks = this.props.data.social.map(function (network) {
        return (
          <li key={network.name}>
            <a href={network.url}>
              <i className={network.className}></i>
            </a>
          </li>
        );
      });
    }

    return (
      <header id="home">
        <nav id="nav-wrap">
          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
            Show navigation
          </a>
          <a className="mobile-btn" href="#home" title="Hide navigation">
            Hide navigation
          </a>

          <ul id="nav" className="nav">
            <li id="home-page">
              <a className="smoothscroll" href="#home">
                Home
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#about" id="about-page">
                About
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#resume" id="resume-page">
                Resume
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#portfolio" id="works-page">
                Works
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#blog" id="blog-page">
                Blog
              </a>
            </li>
            <li>
              <a className="smoothscroll" href="#contact" id="contact-page">
                Contact
              </a>
            </li>
          </ul>
        </nav>

        <div className="row banner">
          <div className="banner-text">
            <h1 className="responsive-headline">
              <span className="turquoise">I</span>
              <span className="red">'</span>
              <span className="yellow">m</span>
              &nbsp;
              <span className="green">B</span>
              <span className="red">o</span>
              <span className="blue">b</span>
              &nbsp;
              <span className="yellow">L</span>
              <span className="red">a</span>
              <span className="blue">m</span>
              <span className="green">.</span>
            </h1>
            <h3>
              I'm a <span>{occupation}</span> living in <span>{city}</span>.{" "}
              {description}.
            </h3>
            <hr />
            <ul className="social">{networks}</ul>
          </div>
        </div>

        <p className="scrolldown">
          <a className="smoothscroll" href="#about">
            <i className="icon-down-circle"></i>
          </a>
        </p>
      </header>
    );
  }
}

export default Header;
